<template>
  <div>
    <ContentHeader />
    <div class="content-container">
      <div class="condition-line">
        <SearchRow @handleFilter="handleFilter">
          <!-- 这个button颜色可能不对需要调整 -->
          <div class="feature-btn upload-btn cursor" @click="toFreezerApply">
            <i class="iconfont iconzu111" />领用资产管理
          </div>
        </SearchRow>
      </div>

      <div v-if="freezerList.length" v-loading="listLoading" class="freezer-list">
        <div class="item-card" v-for="item in freezerList" :key="item.freezerId">
          <el-card shadow="hover" class="cursor" @click.native="viewFreezerDetail(item)">
            <div class="item-img">
              <img :src="getImageUrl(item)" />
            </div>
            <div class="item-info">
              <div class="item-name">{{ item.itemName }}</div>
            </div>
            <div class="item-num">
              <div style="text-align: right">DAG:进行中</div>
            </div>
          </el-card>
        </div>
      </div>
      <div v-else class="no-data">当前无冰柜信息</div>

      <div class="pag-row" v-if="freezerList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import ContentHeader from '../../components/content-header'
import SearchRow from './components/search-row'
import freezerApi from '@/api/freezer'
export default {
  name: 'freezer-list',
  components: {
    ContentHeader,
    SearchRow
  },
  data () {
    return {
      queryParam: {
        page: 1,
        pageSize: 12,
        abiBrandId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        isQuotaIceBox: 1
      },
      total: null,
      freezerList: [],
      listLoading: false
    }
  },
  created () {
    this.queryFreezerList()
  },
  methods: {
    toFreezerApply () {
      this.$router.push('/freezer/apply')
    },

    // 获取所有的冰柜商品
    queryFreezerList () {
      this.listLoading = true
      freezerApi.queryAllFreezerList(this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.freezerList = res.data.resultData.itemList
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },

    // 搜索
    handleFilter (value) {
      this.queryParam.abiBrandId = value.abiBrandId
      this.queryParam.keyword = value.keyword
      this.queryParam.minPrice = value.minPrice
      this.queryParam.maxPrice = value.maxPrice
      this.queryFreezerList()
    },

    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryFreezerList()
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    // 商品详情
    viewFreezerDetail (freezer) {
      this.$router.push({ path: '/freezer/detail', query: { freezerId: freezer.itemId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.freezer-list {
  width: 100%;
  .item-card {
    width: 25%;
    display: inline-block;
    padding: 10px;
    box-sizing: border-box;
    .el-card {
      width: 100%;
      height: 330px;
      padding-top: 10px;
      .item-img {
        width: 100%;
        height: 180px;
        text-align: center;
        img {
          max-height: 100%;
          max-width: 100%;
        }
      }
      .item-info {
        height: 90px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        .item-price {
          color: $base-red;
          font-size: 28px;
          font-weight: bold;
          padding-top: $content-middle;
        }
        .item-name {
          color: #000;
          font-size: 18px;
          font-weight: bold;
          padding: 15px 0 10px 0;
        }
        .item-name:hover {
          color: $base-red;
        }
        .item-desc {
          color: #666;
          font-size: $font-14;
        }
      }
      .item-num {
        height: 50px;
        line-height: 50px;
        color: #666;
        font-size: $font-12;
        padding: 0 $content-middle;
      }
    }
  }
}
</style>
